import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
   providedIn: 'root'
})


export class IstatDataService {

   istatElencoComuniData: any;
   
   constructor(private utils: UtilsService) {}

    
   istatElencoComuniList(): Observable<any> {
      return this.utils.getRequest(this.utils.creaURL('analysis', 'istatElencoComuniList'), {});
   }



}